export const DESIGN_BASE_FONT_SIZE = 16;
export const BASE_FONT_SIZE = 14;

export function pixelSizeHelper(
  designBaseFontSize: number,
  actualFontBaseSize: number
) {
  return (pixelSizeInDesign: number) =>
    Math.floor((pixelSizeInDesign / designBaseFontSize) * actualFontBaseSize);
}

/** converts figma px values to portal px units */
export const pixelSizeHelperPortalUi = pixelSizeHelper(
  DESIGN_BASE_FONT_SIZE,
  BASE_FONT_SIZE
);
